import { FC, useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useHistory, useRouteMatch } from 'react-router-dom';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { LayoutSplashScreen } from 'src/app/layout';
import MasterDataSettingForm from './components/master-data-setting-form';
import { MasterDataFormMode, MasterDataSettingListItem } from '../../../types/master-data-setting-types';
import { fetchMasterDataSettingItem } from '../../../network/master-data-setting-crud';
import { masterDataSettingPath } from '../master-data-setting-routes';

const MasterDataSettingDetailPage: FC = () => {
  const { id } = useParams<{ id: string }>();
  const isViewRoute = useRouteMatch(`${masterDataSettingPath}/view/:id`);
  const formMode = useMemo(() => {
    if (!id) return MasterDataFormMode.CREATE;
    return isViewRoute ? MasterDataFormMode.VIEW : MasterDataFormMode.EDIT;
  }, [id, isViewRoute]);
  const dispatch = useDispatch();
  const history = useHistory();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [masterDataItem, setMasterDataItem] = useState<MasterDataSettingListItem>();

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      fetchMasterDataSettingItem(id, dispatch)
        .then((res) => setMasterDataItem(res))
        .catch(() => history.push(NOT_FOUND_ERROR_PAGE_PATH))
        .finally(() => setIsLoading(false));
    }
  }, [id]);

  return (
    <>
      {formMode === MasterDataFormMode.CREATE && <MasterDataSettingForm formMode={formMode} />}
      {formMode !== MasterDataFormMode.CREATE &&
        (isLoading || !masterDataItem ? (
          <LayoutSplashScreen />
        ) : (
          <MasterDataSettingForm formMode={formMode} masterDataItem={masterDataItem} />
        ))}
    </>
  );
};

export default MasterDataSettingDetailPage;
